import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../styles/common/AdminPageHeader.css';

const AdminPageHeader = ({ 
  title,
  icon,
  subtitle,
  actions = null,
  stats = null,
  className = ''
}) => {
  return (
    <div className={`admin-page-header ${className}`}>
      <div className="header-content">
        <div className="header-info">
          {icon && (
            <div className="header-icon">
              {icon}
            </div>
          )}
          <div className="header-text">
            <h1 className="header-title">{title}</h1>
            {subtitle && <p className="header-subtitle">{subtitle}</p>}
          </div>
        </div>
        {actions && (
          <div className="header-actions">
            {actions}
          </div>
        )}
      </div>
      
      {stats && stats.length > 0 && (
        <div className="header-stats">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                {stat.icon && (
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={stat.icon} />
                  </div>
                )}
                <div className="stat-content">
                  <div className="stat-label">{stat.label}</div>
                  <div className="stat-number">{stat.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPageHeader;
